;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="fde7cb86-0c65-4951-9dd2-0e2d5b3701ee",e._sentryDebugIdIdentifier="sentry-dbid-fde7cb86-0c65-4951-9dd2-0e2d5b3701ee")}catch(e){}}();import classNames from './node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import React__default, { useContext, useRef } from 'react';
import styles from './App.module.scss.js';
import LowerMenu from './components/LowerBar/LowerBar.js';
import './_virtual/_sentry-release-injection-file.js';
import MiddleBar from './components/MiddleBar/MiddleBar.js';
import MobileSearchBar from './components/SearchBar/MobileSearchBar.js';
import TopBarComponent from './components/TopBar/TopBar.js';
import AppContext from './context/AppContext.js';
import { BURGER_PANEL_PORTAL, THEME_CLASSNAME_MAP } from './utils/constants.js';
import { getWebFonts } from './utils/fontUtils.js';
import { SentryBoundary } from './utils/SentryBoundary.js';
import { useHeaderVersion } from './utils/useHeaderVersion.js';

function Header() {
    const { showCategories, isError, showSearch, bundle } = useContext(AppContext);
    useHeaderVersion();
    const headerRef = useRef(null);
    if (isError)
        return null;
    const themeClass = THEME_CLASSNAME_MAP[bundle];
    const fonts = getWebFonts(bundle === 'bitiba');
    return (React__default.createElement(SentryBoundary, null,
        React__default.createElement("div", { className: classNames(styles.wrapper, themeClass), "data-zta": "shop-header" },
            React__default.createElement("style", { "data-zta": "shop-header-fonts" }, fonts),
            React__default.createElement("header", { className: styles.header, "data-zta": "shop-header-component", id: "shop-header", ref: headerRef },
                React__default.createElement("div", { className: classNames(styles.topBarWrapper) },
                    React__default.createElement(TopBarComponent, null)),
                React__default.createElement("div", { className: classNames(styles.middleBarWrapper) },
                    React__default.createElement(MiddleBar, null)),
                React__default.createElement("div", { id: BURGER_PANEL_PORTAL }),
                showCategories && (React__default.createElement("div", { className: classNames(styles.lowerBarWrapper) },
                    React__default.createElement(LowerMenu, null)))),
            showSearch && React__default.createElement(MobileSearchBar, null))));
}

export { Header as default };
//# sourceMappingURL=Header.js.map
